import React from 'react';

import { Col, Row, Tab, Nav } from '@themesberg/react-bootstrap';
import { getCollectorData } from '../helpers/getCollectorData';

const CustomerDescriptionCard = (customerData) => {
  return (
    <div className='card p-2 mb-5'>
      <Tab.Container defaultActiveKey={getCollectorData()[0].key}>
        <Row>
          <Col lg={3}>
            {getCollectorData().map((item) => (
              <Nav className='nav-tabs d-flex flex-column' key={item.key}>
                <Nav.Item className='customerDesc__navItem'>
                  <Nav.Link eventKey={item.key} className='mb-sm-3 mb-md-0'>
                    {item.title}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            ))}
          </Col>
          <Col lg={9}>
            <Tab.Content>
              {getCollectorData(customerData.customerData).map((item) => (
                <Tab.Pane eventKey={item.key} className='py-4' key={item.key}>
                  <Row>
                    {item?.data &&
                      Object.entries(item?.data).map((objItem, idx) => (
                        <Col
                          md={4}
                          className='mb-5'
                          key={objItem[0] ?? `${idx}`}
                        >
                          <h6>{objItem[0] ?? ''}:</h6>
                          <h7>{objItem[1] ?? ''}</h7>
                        </Col>
                      ))}
                  </Row>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default CustomerDescriptionCard;
